import React from 'react'
import { NavLink, Tooltip } from '@mantine/core';
const MenuItem = ({ active, icon, path, text, onClick }) =>
{
  return (
    <NavLink
      onClick={ onClick }
      variant="light"
      color="yellow"
      active={ active }
      href={ `#${ path }` }
      label={ text }
      leftSection={ icon }
      styles={{
        root: {
          borderRadius: '4px',
          fontWeight: active ? 800 : 500,
          borderLeft: active ? '3px solid var(--mantine-color-yellow-filled)' : '3px solid transparent',
          backgroundColor: active ? 'var(--mantine-color-yellow-light)' : 'transparent',
          transition: 'all 0.2s ease',
        },
        label: {
          fontSize: 'var(--mantine-font-size-sm)',
          letterSpacing: '0.2px',
          textTransform: 'uppercase',
        }
      }}
    />
  )
}

export default MenuItem
